import { create } from 'zustand';
import { SupportData, SupportSortData } from '../../../shared/dto/EntityRepository';
import { SupportSortOrder, SortDirection, PerPage } from '../../../shared/enum/EnumRepository';



interface AdminSupportViewState {
  // Active support
  activeSupport: SupportData | null;
  setActiveSupport: (support: SupportData | null) => void;
  updateActiveSupport: (updates: Partial<SupportData>) => void;
  afterDeleteActiveSupport: () => void;
  clearActiveSupport: () => void;
}

export const useAdminSupportViewStore = create<AdminSupportViewState>((set) => ({
  // Active support
  activeSupport: null,
  setActiveSupport: (activeSupport) => set({ activeSupport }),
  updateActiveSupport: (updates) =>
    set(({ activeSupport }) => ({
      activeSupport: activeSupport ?
        { ...activeSupport, ...updates }
        : null
    })),
  afterDeleteActiveSupport: () => set({ activeSupport: null }),
  clearActiveSupport: () => set({ activeSupport: null }),
}));


interface AdminSupportListState {
  pageSize: PerPage;
  setPageSize: (pageSize: PerPage) => void;
  sortData: SupportSortData;
  setSortData: (sortData: SupportSortData) => void;
  supportList: SupportData[];
  setSupportList: (supportList: SupportData[]) => void;
  addSupport: (support: SupportData, pageSize: number) => void;
  afterDeleteSupport: (id: string) => void;
}

export const useAdminSupportListStore = create<AdminSupportListState>((set, get) => ({
  pageSize: PerPage.PAGE_10,
  setPageSize: (pageSize) => set({ pageSize }),
  sortData: { sort: SupportSortOrder.CREATED_AT, direction: SortDirection.DESC },
  setSortData: (sortData) => set({ sortData }),
  supportList: [],
  setSupportList: (supportList) => set({ supportList }),
  addSupport: (support, pageSize) => {
    const currentList = get().supportList;
    const newList = [support, ...currentList].slice(0, pageSize);
    set({ supportList: newList });
  },
  afterDeleteSupport: (id: string) => {
    set(({ supportList }) => ({
      supportList: supportList.filter((s) => s.id !== id)
    }));
  },
}));